export class DeviceColour {
    colourName: string;
    hexCode: string;

    constructor(colourName: string, hexCode: string) {
        this.colourName = colourName;
        this.hexCode = hexCode
    }
}